import styled from 'styled-components';

export const Container = styled.div`
  color: red;
  border-radius: 4px;
  padding-left: 8px;
`;
